import { graphql, useStaticQuery } from 'gatsby';

export const useLatestArticles = () => {
  const { allSanityArticle } = useStaticQuery(graphql`
    query {
      allSanityArticle(sort: { fields: date, order: DESC }, limit: 6) {
        edges {
          node {
            date(formatString: "DD MMM YYYY")
            title
            slug {
              current
            }
            summary
            meta {
              metaImage {
                ...ImageWithPreview
              }
            }
          }
        }
      }
    }
  `);
  return allSanityArticle.edges || [];
};
